import { useEffect, useState } from "react";

import "./Home.css"; // Custom CSS for background images and extra styling
import ProgressBars from "./ProgressBars";
import TeamSection from "./TeamSection";
import WorksSection from "./WorksSection";
import MedicaxTestimonials from "./MedicaxTestimonials";
import HomeAboutSection from "./HomeAboutSection";
function About() {
    const [count, setCount] = useState(0);
  const target = 25;
   useEffect(() => {
    if (count < target) {
      const timer = setTimeout(() => {
        setCount(count + 1);
      }, 50); // speed control
      return () => clearTimeout(timer);
    }
  }, [count]);
  return (
    <>
      {/*===== HERO AREA STARTS =======*/}
      <div
        className="inner-header-section-area"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/BG-Orange-shade.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <img
          src="assets/img/elements/elements28.webp"
          alt=""
          className="elements28"
        />
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="hero-header">
                <h1 className="text-anime-style-1">About Us</h1>
                <div className="space28" />
                <a href="index.html" className="bradecrumb">
                  Home <i className="fa-solid fa-angle-right" /> About Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== HERO AREA ENDS =======*/}

      <>
        {/*===== ABOUT AREA STARTS =======*/}
        <div className="about-inner-section-area sp1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="about-all-images">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="images-content">
                        <img
                          src="assets/img/elements/elements9.webp"
                          alt=""
                          className="elements9"
                        />
                        <div className="img1 image-anime reveal">
                          <img
                            src="assets/img/all-images/about/about-img7.webp"
                            alt=""
                          />
                        </div>
                        <div className="space24" />
                        <div className="experiance-box">
                          <h3>
                            <span className="counter">{count}</span>+
                          </h3>
                          <p>Years of Healthcare Excellence</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="img1 image-anime reveal">
                        <img
                          src="assets/img/all-images/about/about-img20.webp"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="heading4">
                  <h5
                    className="vl-section-subtitle"
                    data-aos="fade-left"
                    data-aos-duration="800"
                  >
                  JEEVANDAAN Hospital<span> | </span> About Us{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="8"
                      viewBox="0 0 13 8"
                      fill="none"
                    >
                      <path
                        d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992"
                        stroke="#b2442c"
                        strokeWidth={1.5}
                      />
                    </svg>
                  </h5>
                  <div className="space20" />
                  <h2 className="text-anime-style-3">
                    Experience Care That Goes Beyond Treatment

                  </h2>
                  <div className="space18" />
                  <p data-aos="fade-left" data-aos-duration="1000">
                   At JEEVANDAAN Hospital, we are committed to delivering comprehensive medical care, accurate diagnosis, and compassionate treatment through experienced doctors and modern healthcare facilities - because your life and well-being truly matter.
                  </p>
                  <div className="space28" />
                  <ProgressBars />
                  <div className="space32" />
                  <div className="btn-area1">
                    <a href="contact.html" className="vl-btn4">
                      Schedule An Appointment{" "}
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          /*===== ABOUT AREA ENDS =======*/

          <>
            <div className="slider4-section-area">
              <div className="marquee-wrap">
                <div className="marquee-text">
                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Personalized Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Experienced Professionals
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Advanced Technology
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Preventive Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Patient-Centered Approach
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Personalized Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Experienced Professionals
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      {" "}
                      <img src="assets/img/elements/elements1.png" alt="" />
                      Advanced Technology
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Preventive Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Patient-Centered Approach
                    </h3>
                  </div>
                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Personalized Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Experienced Professionals
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Advanced Technology
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Preventive Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Patient-Centered Approach
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            {/*===== ABOUT AREA STARTS =======*/}
            <HomeAboutSection />
            {/*===== ABOUT AREA ENDS =======*/}
            <TeamSection />

            {/*===== WORKS AREA STARTS =======*/}
            <WorksSection />

            {/*===== WORKS AREA ENDS =======*/}

            {/*===== TESTIMONIAL AREA STARTS =======*/}
           <MedicaxTestimonials />
            <div className="slider4-section-area">
              <div className="marquee-wrap">
                <div className="marquee-text">
                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Personalized Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Experienced Professionals
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Advanced Technology
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Preventive Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Patient-Centered Approach
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Personalized Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Experienced Professionals
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      {" "}
                      <img src="assets/img/elements/elements1.png" alt="" />
                      Advanced Technology
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Preventive Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Patient-Centered Approach
                    </h3>
                  </div>
                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Personalized Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Experienced Professionals
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Advanced Technology
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Preventive Care
                    </h3>
                  </div>

                  <div className="brand-single-box">
                    <h3>
                      <img src="assets/img/elements/elements1.png" alt="" />{" "}
                      Patient-Centered Approach
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <>
              {/*===== CONTACT AREA STARTS =======*/}
              <div className="contact-heading">
                <div className="space100 d-lg-block d-none" />
                <div className="space50 d-lg-none d-block" />
                <div className="container">
                  <div className="row">
                    <div className="col-lg-8 m-auto">
                      <div className="heading4 text-center space-margin60">
                        <h5 className="vl-section-subtitle">
                        JEEVANDAAN Hospital<span> | </span>Ready to Take the First Step?{" "}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="8"
                            viewBox="0 0 13 8"
                            fill="none"
                          >
                            <path
                              d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992"
                              stroke="#b2442c"
                              strokeWidth={1.5}
                            />
                          </svg>
                        </h5>
                        <div className="space24" />
                        <h2 className="vl-section-title text-anime-style-3">
                          Book Your Consultation at JEEVANDAAN Hospital

                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="contact1-section-area4"
                style={{
                  backgroundImage:
                    "url(assets/img/all-images/contact/contact-img1.webp)",
                  backgroundPosition: "center top",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
              >
                <img
                  src="assets/img/all-images/bg/contact-bg.webp"
                  alt=""
                  className="contact-bg"
                />
                <div className="container">
                  <div className="row">
                    <div className="col-lg-7">
                      <div className="contact-single-boxarea">
                        <div className="row">
                          <div
                            className="col-lg-6 col-md-6"
                            data-aos="zoom-in-up"
                            data-aos-duration="800"
                          >
                            <div className="single-box">
                              <div className="icons">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="33"
                                  height="32"
                                  viewBox="0 0 33 32"
                                  fill="none"
                                >
                                  <path
                                    d="M16.305 29.3327C23.6688 29.3327 29.6383 23.3631 29.6383 15.9993C29.6383 8.63555 23.6688 2.66602 16.305 2.66602C8.94122 2.66602 2.97168 8.63555 2.97168 15.9993C2.97168 23.3631 8.94122 29.3327 16.305 29.3327Z"
                                    stroke="#1C293F"
                                    strokeWidth={2.5}
                                  />
                                  <path
                                    d="M16.9351 9.15785C16.9351 8.51839 16.4167 8 15.7772 8C15.1378 8 14.6194 8.51839 14.6194 9.15785H16.9351ZM18.9116 18.3738C18.4594 17.9217 17.7264 17.9217 17.2743 18.3738C16.8221 18.826 16.8221 19.559 17.2743 20.0112L18.9116 18.3738ZM19.59 22.3269C20.0421 22.7791 20.7751 22.7791 21.2273 22.3269C21.6795 21.8747 21.6795 21.1417 21.2273 20.6895L19.59 22.3269ZM14.6194 9.15785V14.5611H16.9351V9.15785H14.6194ZM17.2743 20.0112L19.59 22.3269L21.2273 20.6895L18.9116 18.3738L17.2743 20.0112ZM16.9351 16.8768C16.9351 17.5163 16.4167 18.0347 15.7772 18.0347V20.3504C17.6956 20.3504 19.2508 18.7951 19.2508 16.8768H16.9351ZM15.7772 18.0347C15.1378 18.0347 14.6194 17.5163 14.6194 16.8768H12.3037C12.3037 18.7951 13.8589 20.3504 15.7772 20.3504V18.0347ZM14.6194 16.8768C14.6194 16.2374 15.1378 15.719 15.7772 15.719V13.4033C13.8589 13.4033 12.3037 14.9585 12.3037 16.8768H14.6194ZM15.7772 15.719C16.4167 15.719 16.9351 16.2374 16.9351 16.8768H19.2508C19.2508 14.9585 17.6956 13.4033 15.7772 13.4033V15.719Z"
                                    fill="#1C293F"
                                  />
                                </svg>
                              </div>
                              <div className="text">
                                <h4>Schedule</h4>
                                {/* <div className="space14" /> */}
                                <a href="#">Sun–Fri | 9:00 AM – 6:00 PM</a>
                              </div>
                            </div>
                          </div>

                          <div
                            className="col-lg-6 col-md-6"
                            data-aos="zoom-in-up"
                            data-aos-duration="900"
                          >
                            <div className="single-box">
                              <div className="icons">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="33"
                                  height="32"
                                  viewBox="0 0 33 32"
                                  fill="none"
                                >
                                  <path
                                    d="M16.3031 28C20.9697 23.2 25.6364 18.9019 25.6364 13.6C25.6364 8.29807 21.4577 4 16.3031 4C11.1484 4 6.96973 8.29807 6.96973 13.6C6.96973 18.9019 11.6364 23.2 16.3031 28Z"
                                    stroke="#1C293F"
                                    strokeWidth={2.2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M16.3037 17.332C18.5129 17.332 20.3037 15.5412 20.3037 13.332C20.3037 11.1229 18.5129 9.33203 16.3037 9.33203C14.0945 9.33203 12.3037 11.1229 12.3037 13.332C12.3037 15.5412 14.0945 17.332 16.3037 17.332Z"
                                    stroke="#1C293F"
                                    strokeWidth={2.2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <div className="text">
                                <h4>locations</h4>
                                {/* <div className="space14" /> */}
                                <a href="#">Bhopal, Madhya Pradesh ,India</a>
                              </div>
                            </div>
                          </div>

                          <div
                            className="col-lg-6 col-md-6"
                            data-aos="zoom-in-up"
                            data-aos-duration="1000"
                          >
                            <div className="single-box">
                              <div className="icons">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="33"
                                  height="32"
                                  viewBox="0 0 33 32"
                                  fill="none"
                                >
                                  <path
                                    d="M6.13704 24.0013L12.8037 16.0013M27.4704 24.0013L20.8037 16.0013M4.80371 10.668L14.437 17.0901C15.2924 17.6604 15.72 17.9456 16.1822 18.0562C16.5908 18.1542 17.0166 18.1542 17.4252 18.0562C17.8874 17.9456 18.315 17.6604 19.1704 17.0901L28.8037 10.668M9.07038 25.3346H24.537C26.0305 25.3346 26.7773 25.3346 27.3477 25.044C27.8494 24.7884 28.2574 24.3804 28.513 23.8786C28.8037 23.3082 28.8037 22.5614 28.8037 21.068V10.9346C28.8037 9.44117 28.8037 8.69442 28.513 8.124C28.2574 7.62222 27.8494 7.21428 27.3477 6.95862C26.7773 6.66797 26.0305 6.66797 24.537 6.66797H9.07038C7.57691 6.66797 6.83016 6.66797 6.25974 6.95862C5.75796 7.21428 5.35002 7.62222 5.09436 8.124C4.80371 8.69442 4.80371 9.44116 4.80371 10.9346V21.068C4.80371 22.5614 4.80371 23.3082 5.09436 23.8786C5.35002 24.3804 5.75796 24.7884 6.25974 25.044C6.83016 25.3346 7.5769 25.3346 9.07038 25.3346Z"
                                    stroke="#1C293F"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <div className="text">
                                <h4>Our Email</h4>
                               {/*  <div className="space14" /> */}
                                <a href="jeevandanhospital.hr@gmail.com">
                                 jeevandanhospital.hr@gmail.com
                                </a>
                              </div>
                            </div>
                          </div>

                          <div
                            className="col-lg-6 col-md-6"
                            data-aos="zoom-in-up"
                            data-aos-duration="1100"
                          >
                            <div className="single-box">
                              <div className="icons">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="33"
                                  height="32"
                                  viewBox="0 0 33 32"
                                  fill="none"
                                >
                                  <path
                                    d="M19.037 7.99935C20.3394 8.25344 21.5362 8.89036 22.4745 9.8286C23.4128 10.7668 24.0497 11.9637 24.3037 13.266M19.037 2.66602C21.7428 2.9666 24.2658 4.17824 26.1921 6.10203C28.1182 8.0258 29.3332 10.5474 29.637 13.2527M24.9704 27.9993C13.5565 27.9993 4.30371 18.7465 4.30371 7.33268C4.30371 6.81772 4.32255 6.30716 4.35956 5.80166C4.40204 5.22151 4.42328 4.93144 4.57531 4.66739C4.70123 4.4487 4.92438 4.2413 5.15168 4.13168C5.42612 3.99935 5.74622 3.99935 6.38639 3.99935H10.1428C10.6812 3.99935 10.9503 3.99935 11.1811 4.08795C11.3849 4.16622 11.5664 4.29334 11.7096 4.45815C11.8717 4.64472 11.9637 4.8977 12.1477 5.40363L13.7025 9.67942C13.9165 10.2681 14.0236 10.5624 14.0054 10.8416C13.9894 11.0878 13.9053 11.3248 13.7626 11.5261C13.6009 11.7544 13.3323 11.9155 12.7952 12.2378L10.9704 13.3327C12.5729 16.8645 15.4372 19.7325 18.9704 21.3327L20.0653 19.5079C20.3876 18.9707 20.5486 18.7021 20.7769 18.5404C20.9782 18.3977 21.2152 18.3136 21.4614 18.2976C21.7406 18.2795 22.035 18.3865 22.6237 18.6005L26.8994 20.1553C27.4053 20.3393 27.6584 20.4313 27.8449 20.5935C28.0097 20.7367 28.1369 20.9181 28.215 21.122C28.3037 21.3527 28.3037 21.6219 28.3037 22.1603V25.9167C28.3037 26.5568 28.3037 26.877 28.1713 27.1514C28.0617 27.3787 27.8544 27.6019 27.6357 27.7278C27.3716 27.8798 27.0816 27.9009 26.5014 27.9435C25.9958 27.9805 25.4853 27.9993 24.9704 27.9993Z"
                                    stroke="#1C293F"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <div className="text">
                                <h4>Phone</h4>
                             {/*    <div className="space14" /> */}
                                <a href="tel:+91 9098852357">+91 9098852357, 8269900698</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-lg-5"
                      data-aos="zoom-in-up"
                      data-aos-duration="1000"
                    >
                      <div className="contact-boxarea">
                        <h4>book An Appointment</h4>
                        <div className="space20" />
                        <p>
                         Booking a consultation is the first step toward better health.{" "}
                          <br className="d-lg-block d-none" /> At JEEVANDAAN Hospital, our experienced doctors are here to provide trusted guidance, accurate diagnosis, and personalized treatment for your well-being.{" "}
{" "}
                        </p>
                        <div className="space6" />
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="input-area">
                              <input type="text" placeholder="Full Name*" />
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="input-area">
                              <input
                                type="number"
                                placeholder="Phone Number*"
                              />
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="input-area">
                              <input
                                type="email"
                                placeholder="Email Address*"
                              />
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="input-area">
                              <select
                                name="country"
                                id="country"
                                className="country-area nice-select"
                              >
                                <option value="1" data-display="Service Type">
                                  Service Type
                                </option>
                                <option value={true}>
                                  {" "}
                                  General Medical Services
                                </option>
                                <option value={true}>
                                  {" "}
                                  Specialist Services
                                </option>
                                <option value={true}>
                                  {" "}
                                  Women’s Health Services
                                </option>
                                <option value={true}>
                                  {" "}
                                  Mental Health and Wellness
                                </option>
                                <option value={true}>
                                  {" "}
                                  Diagnostic and Laboratory Services
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="input-area">
                              <select
                                name="country"
                                id="country1"
                                className="country-area nice-select"
                              >
                                <option value="1" data-display="Select Doctor*">
                                  Select Doctor*
                                </option>
                                <option value={true}>
                                  {" "}
                                  Dr. Emily Carter - Cardiologist
                                </option>
                                <option value={true}>
                                  {" "}
                                  Dr. Michael - Orthopedic Surgeon
                                </option>
                                <option value={true}>
                                  {" "}
                                  Dr. Olivia - Dermatologist
                                </option>
                                <option value={true}>
                                  {" "}
                                  Dr. Ethan Brown - Pediatrician
                                </option>
                                <option value={true}>
                                  {" "}
                                  Dr. Ava Davis - Neurologist
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="input-area">
                              <input type="date" />
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="input-area">
                              <textarea placeholder="Your Message" />
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="space10" />
                            <div className="input-area">
                              <button type="submit" className="vl-btn4">
                                Complete Your Appointment Now{" "}
                                <span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z"
                                      fill="white"
                                    />
                                  </svg>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="space100 d-lg-block d-none" />
              <div className="space50 d-lg-none d-block" />
              {/*===== CONTACT AREA ENDS =======*/}
            </>
          </>
        }
      </>
    </>
  );
}

export default About;
